import { render, staticRenderFns } from "./ChartjsHorizontalBarChartHappiness.vue?vue&type=template&id=5a8736b1&"
import script from "./ChartjsHorizontalBarChartHappiness.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartHappiness.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartHappiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports